@use "foundation/_colors.scss";
@use "foundation/responsive";

$header-border-space: 2.25em;
$header-border-space-phone: 1em;

header.diy-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  & > *:not(h1) {
    flex: 0.25; // Try to keep side elements evenly spaced, so the title is centered

    &:last-child {
      text-align: right;
    }
  }

  height: 6em;
  padding: 0 $header-border-space;

  @include responsive.phone {
    padding: 0 $header-border-space-phone;
  }

  h1 {
    text-align: center;
    font-size: 32px;
    font-weight: 700;
    line-height: 1.1;

    @include responsive.small-phone {
      font-size: 1.375em; // 22px on small phones to keep longer titles on one line
    }
  }

  &.on-color {
    border-bottom: 1px solid rgba(245, 245, 245, 0.2);
  }

  // Conversational UI header (chatEnableNew + initial step). Cancel/help
  // are fixed-size icon buttons; the surrounding `flex: 0.25` rule above
  // would otherwise stretch them to ~25% of the header width.
  &.chat-style {
    height: auto;
    padding: 16px 16px 0;
    align-items: center;

    & > *:not(h1) {
      flex: none;
      width: 52px;
      height: 52px;

      &:last-child {
        text-align: initial;
      }
    }

    h1 {
      margin: 0;
    }
  }
}
